import { NgClass, NgIf } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewEncapsulation,
  input
} from "@angular/core";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-counter-input",
    templateUrl: "./counter-input.component.html",
    styleUrls: ["./counter-input.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CounterInputComponent),
            multi: true,
        },
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [IonicModule, FormsModule, ReactiveFormsModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CounterInputComponent implements ControlValueAccessor {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("counterValue") _counterValue = 0;
  readonly label = input(undefined);
  readonly rightAlign = input(false);
  @Output() input = new EventEmitter();

  propagateChange: any = () => {}; // Noop function

  get counterValue() {
    return this._counterValue;
  }

  set counterValue(val) {
    this._counterValue = val;
    this.propagateChange(val);
  }

  writeValue(value: number) {
    if (value) {
      this.counterValue = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value);
    if (!isNaN(value)) {
      this.counterValue = value;
      this.input.emit(this.counterValue);
    }
  }

  increase() {
    this.counterValue = Math.round((this.counterValue + 1) * 100) / 100; // Round to 2 decimal places
    this.input.emit(this.counterValue);
  }

  decrease() {
    if (this.counterValue > 0) {
      this.counterValue = Math.round((this.counterValue - 1) * 100) / 100; // Round to 2 decimal places
      this.input.emit(this.counterValue);
    }
  }
}
